import React, { useEffect, useState } from 'react'
import { images } from '../../../assets'
import { useNavigate } from 'react-router-dom'

const SuccessPopupWithDownloadApp = ({ open }) => {
    const navi = useNavigate();
    const [OS, setOS] = useState('')

    const onClickButton = () => {
        if (OS === 'android') {
            window.location.href = 'https://vvd.bz/e5s6'
        } else if (OS === 'ios') {
            window.location.href = 'https://vvd.bz/eYrN';
        } else {
            navi('/');
        }
    }
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            setOS('android')
        } else if (/iPad|iPhone|iPod/.test(userAgent)) {
            setOS('ios')
        } else {
            setOS('web')
        }
    }, [])

    useEffect(() => {
        if (open) {
            document.querySelector('.application_sheet').scrollTop = 0
        }
    }, [open])

    return (
        <div className="SuccessPopup SuccessPopup--simple">
            <div className={open ? 'open success_popup notice_popup' : 'success_popup notice_popup'}>
                <div className="logo_brg"></div>
                <p>
                    <span
                        className="logo_success"
                        style={{
                            display: 'block'
                        }} />
                </p>


                <p style={{ textAlign: 'center', size: '19px' }}>
                    스폰지 사장님 앱으로 <br />
                    사장님이 직접 배달앱 리뷰를 확인하고 <br />
                    댓글까지 작성할 수 있습니다.
                </p>

                <div>
                    <div className="feature_warp">
                        <p className='feature_title'>주요 기능</p>
                        <div className='feature'>
                            <div className="feature_box">
                                <img src={images.chat_icon} alt="chatIcon" />
                                <p>댓글 자동 등록일 설정</p>
                            </div>
                            <div className="feature_box">
                                <img src={images.comment_icon} alt="commentIcon" />
                                <p>추가 댓글 설정</p>
                            </div>
                            <div className="feature_box">
                                <img src={images.like_icon} alt="likeIcon" />
                                <p>리뷰 현황 확인</p>
                            </div>
                        </div>
                    </div>
                    <button type="button" className="btn_default" onClick={onClickButton}>
                        {OS === 'web' ? ' 확인' : '스폰지 사장님 앱 다운로드'}
                    </button>
                </div>
            </div>
        </div >
    )
}

export { SuccessPopupWithDownloadApp }


